import { connect } from "react-redux";

import { DebtorType, WageScheduleType } from "types";
import { setNotice } from "actions/notifications";
import { setDebtor } from "actions/wageDebtors";

import Edit from "./Edit";

interface StatePropsType {
  debtor: DebtorType;
  wageSchedule: WageScheduleType;
}

interface DispatchPropsType {
  setDebtor: Function;
  setNotice: Function;
}

const mapStateToProps = (state): StatePropsType => ({
  debtor: state.wageDebtors.debtor,
  wageSchedule: state.wageDebtors.wageSchedule,
});

const mapDispatchToProps = (dispatch: Function): DispatchPropsType => ({
  setDebtor: (debtor: DebtorType): void => {
    dispatch(setDebtor(debtor));
  },
  setNotice: (notice: string): void => {
    dispatch(setNotice(notice));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Edit);
